import appConfig from '../../config/appConfig';
import * as localizationKeys from '../../consts/localization/localizationKeys';
import NotificationModalTypes from '../../enums/app/notificationModalTypes';
import {hideAllLoaders, setNotificationFailed, setNotificationInfo} from '../../state/ducks/global';
import {selectDeviceNameKey} from '../../state/selectors/consumer';
import {makeSelectIotDeviceData} from '../../state/selectors/iotDevice';
import {dispatch, getState} from '../../state/store';
import connectivityService from '../device/connectivityService';
import {getLocalizedStrings} from '../localization/localizationService';
import pairingService from '../pairingService';
import appRouterService from '../route/appRouterService';

//TODO: move to notificationService
const showDeviceSettingsGlobalError = () => {
    dispatch(setNotificationInfo({textKey: localizationKeys.DEVICE_SETTINGS_GLOBAL_ERROR}));
};

const showError = (errorKey) => dispatch(setNotificationFailed({textKey: errorKey}));

const showDeviceDisconnectNotification = (testId) => {
    prepareNotification(false, testId);
};

const showDeviceHolderDisconnectNotification = () => {
    prepareNotification(true);
};

const prepareNotification = (isHolder, testId) => {
    const isReconnectDeviceGuideEnabled = appConfig.getIsReconnectDeviceGuideEnabled();
    const isBle = connectivityService.isBle();
    const isNotificationType = isReconnectDeviceGuideEnabled && isBle && !isHolder;
    const notificationType = isNotificationType ? NotificationModalTypes.RECONNECT_DEVICE : null;
    const deviceNameKey = selectDeviceNameKey(getState());
    const localizedStrings = getLocalizedStrings();

    dispatch(
        setNotificationInfo({
            textKey: localizationKeys.DEVICE_LOST_CONNECTION_NOTIFICATION_PART_1,
            textFormatValues: deviceNameKey ? localizedStrings[deviceNameKey] : '',
            testId,
            notificationType,
        })
    );
};

const showGlobalError = () => {
    showError(localizationKeys.GLOBAL_ERROR_WITH_RETRY_DESCRIPTION_TEXT);
};

const showGlobalErrorWithAppHardReset = () => {
    showError(
        getBleOrUsbErrorKey(
            localizationKeys.BLE_GLOBAL_ERROR_NOTIFICATION_TEXT,
            localizationKeys.USB_GLOBAL_ERROR_NOTIFICATION_TEXT
        )
    );
    pairingService.disconnectAndClearState();
    appRouterService.forwardToBrowserVerificationPage();
};

const showErrorWithAppReset = (errorKey) => {
    pairingService.disconnectAndForwardToStartPage();
    showError(errorKey);
    dispatch(hideAllLoaders());
};

const showGlobalErrorWithAppReset = () =>
    showErrorWithAppReset(
        getBleOrUsbErrorKey(
            localizationKeys.BLE_GLOBAL_ERROR_NOTIFICATION_TEXT,
            localizationKeys.USB_GLOBAL_ERROR_NOTIFICATION_TEXT
        )
    );

const showIoErrorWithAppReset = () => {
    showErrorWithAppReset(
        getBleOrUsbErrorKey(
            localizationKeys.BLE_GLOBAL_ERROR_NOTIFICATION_TEXT,
            localizationKeys.USB_GLOBAL_ERROR_NOTIFICATION_TEXT
        )
    );
};

const showDeviceSettingsError = (isHolder) => {
    if (isHolder) {
        const iotDevice = makeSelectIotDeviceData()(getState());
        const {device} = iotDevice || {};
        const {isHolderConnected} = device || {};

        if (!isHolderConnected) {
            showDeviceHolderDisconnectNotification();
        } else {
            showDeviceSettingsGlobalError();
        }
    } else {
        showDeviceSettingsGlobalError();
    }
};

const getBleOrUsbErrorKey = (bleKey, usbKey) => (connectivityService.isBle() ? bleKey : usbKey);

export default {
    showDeviceDisconnectNotification,
    showDeviceHolderDisconnectNotification,
    showDeviceSettingsGlobalError,
    showGlobalError,
    showGlobalErrorWithAppHardReset,
    showGlobalErrorWithAppReset,
    showIoErrorWithAppReset,
    showDeviceSettingsError,
};
